import React from "react";
import { FaLinkedin, FaInstagram } from "react-icons/fa";
import t1 from "../assets/team-leo/anshuman.png";
import t2 from "../assets/team-leo/ashish.png";
import t3 from "../assets/team-leo/disha.png";
import t4 from "../assets/team-leo/divyansh.png";
import t5 from "../assets/team-leo/gaurav.png";
import t6 from "../assets/team-leo/kashish.png";
import t7 from "../assets/team-leo/khushi.png";
import t8 from "../assets/team-leo/koyam.png";
import t9 from "../assets/team-leo/priyanshi.png";
import t10 from "../assets/team-leo/ruhani.png";
import t11 from "../assets/team-leo/sana.png";
import t12 from "../assets/team-leo/tarishi.png";
import t13 from "../assets/team-leo/utkarsh.png";
import t14 from "../assets/team-leo/varsha.png";
import t15 from "../assets/team-leo/rupayan.png";
import t16 from "../assets/team-leo/aashlok.png";
import t17 from "../assets/team-leo/kanishk.png";
import t18 from "../assets/team-leo/gautam.png";

const latestTeam = [
  {
    name: "Kanishk Verma",
    role: "President",
    image: t17,
    linkedin: "https://www.linkedin.com/in/kanishk-verma-432b74225/",
    instagram: "https://www.instagram.com/kanishk.xx/",
  },
  {
    name: "Aashlok Kumar",
    role: "Vice President",
    image: t16,
    instagram: "https://www.instagram.com/aashlok_3235",
  },
  {
    name: "Sana Nargis",
    role: "Secretary",
    image: t11,
    instagram: "https://www.instagram.com/sanaa___111",
  },
  {
    name: "Gautam",
    role: "Treasurer",
    image: t18,
    linkedin:
      "https://www.linkedin.com/in/gautam-ramawat?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    instagram: "https://www.instagram.com/gautam__ramawat7.0",
  },
  {
    name: "Divyansh Pandit",
    role: "Project Head - Dhruvtara",
    image: t4,
    linkedin:
      "https://www.linkedin.com/in/divyansh-pandit-2a07a121b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
  },
  {
    name: "Varsha Lathwal",
    role: "Associate Head - Dhruvtara",
    image: t14,
    linkedin:
      "https://www.linkedin.com/in/varsha-lathwal-020270263?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
    instagram: "https://www.instagram.com/varsha.lathwal",
  },
  {
    name: "Kashish Prasad",
    role: "Project Head - Parinday",
    image: t6,
    instagram: "https://www.instagram.com/kashishprasad_",
  },
  {
    name: "Koyam",
    role: "Associate Head - Parinday",
    image: t8,
    instagram: "https://www.instagram.com/_koyam._",
  },
  {
    name: "Rupayan",
    role: "Project Head - Vitt Vichaar",
    image: t15,
    linkedin:
      "https://www.linkedin.com/in/rupayan-majumder-9bb340294?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    instagram: "https://www.instagram.com/rupayan_atw",
  },
  {
    name: "Disha Rajpurohit",
    role: "Associate Head - Vitt Vichaar",
    image: t3,
    linkedin: "https://www.linkedin.com/in/disha-rajpurohit-believeinbig",
    instagram: "https://www.instagram.com/disharajpurohit_31",
  },
  {
    name: "Ruhani Singh",
    role: "Social Media & Designing Head",
    image: t10,
    instagram: "https://www.instagram.com/ruhaaaani",
  },
  {
    name: "Gaurav Kumar",
    role: "Social Media & Designing Co-Head",
    image: t5,
    instagram: "https://www.instagram.com/gaurav.dhoni07",
  },
  {
    name: "Tarishi",
    role: "Social Media & Designing Co-Head",
    image: t12,
    instagram: "https://www.instagram.com/coolcaptainruru",
  },

  {
    name: "Khushi Arora",
    role: "PR Officer",
    image: t7,
    instagram: "https://www.instagram.com/__.justk",
  },
  {
    name: "Priyanshi",
    role: "Content Head",
    image: t9,
    instagram: "https://www.instagram.com/b_priyanshi17",
  },
  {
    name: "Anshuman",
    role: "Technical Head",
    image: t1,
    linkedin: "https://www.linkedin.com/in/anshuman-dhiman/",

    instagram: "https://www.instagram.com/anshuman.dhiman",
  },
  {
    name: "Ashish Bharti",
    role: "Technical Co-Head",
    image: t2,
    linkedin: "https://www.linkedin.com/in/ashish-bharti-412a76174",

    instagram: "https://www.instagram.com/programmera_07",
  },
  {
    name: "Utkarsh Goyal",
    role: "Communication Head",
    image: t13,

    instagram: "https://www.instagram.com/oyeuttu_",
  },
];

const Team = () => {
  return (
    <div className="min-h-screen py-16 px-6">
      <div className="max-w-6xl mx-auto text-center">
        <h2 className="text-5xl font-extrabold text-[#1D4C60]">
          Leo Club UoD Core and Cabinet
        </h2>
        <p className="text-gray-500 mt-3 text-lg">
          Meet out passionate team serving as Batch 6 from 2024-2025.
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-10 mt-12">
          {latestTeam.map((member, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-3xl shadow-2xl transform transition-all hover:scale-105"
            >
              <img
                src={member.image}
                alt={member.name}
                className="w-28 h-28 mx-auto rounded-full border-4 border-slate-500"
              />
              <h3 className="mt-6 text-2xl font-bold text-gray-900">
                {member.name}
              </h3>
              <p className="font-medium text-slate-600">{member.role}</p>
              <div className="flex justify-center space-x-4 mt-4">
                {member.linkedin && (
                  <a
                    href={member.linkedin}
                    className="text-2xl text-slate-600 hover:text-slate-800"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaLinkedin />
                  </a>
                )}
                {member.instagram && (
                  <a
                    href={member.instagram}
                    className="text-2xl text-gray-800 hover:text-gray-900"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaInstagram />
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Team;
